export function breakPoints() {
  return {
        phone: 640,
        tablet: 768,
        desktop: 1024,
  }
}
